export function trackEvent(eventName, properties = {}) {
  if (window.testEnv) {
    window.trackEventCalls = window.trackEventCalls || [];
    window.trackEventCalls.push([eventName, properties]);
  } else if (window.mixpanel) {
    window.mixpanel.track(eventName, properties);
  }
}
